import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

const T = {
  en: { subscription_required: "An active subscription is required.", upgrade_required: "This feature isn't in your plan.", quota_exceeded: "Monthly quota reached for this feature.", club_subscription_required: "This club has no active subscription.", club_capacity_reached: "This club reached its player limit.", cta: "See plans" },
  fr: { subscription_required: "Un abonnement actif est requis.", upgrade_required: "Cette fonctionnalité n'est pas dans ton plan.", quota_exceeded: "Quota mensuel atteint pour cette fonctionnalité.", club_subscription_required: "Ce club n'a pas d'abonnement actif.", club_capacity_reached: "Ce club a atteint sa limite de joueurs.", cta: "Voir les plans" },
};

// Global 402 handler → toast with an upgrade CTA
export default function PaywallListener() {
  const nav = useNavigate();
  const { lang } = useLang();
  useEffect(() => {
    const h = (e) => {
      const t = T[lang] || T.en;
      const d = e.detail || {};
      const msg = t[d.code] || t.subscription_required;
      const extra = d.limit ? ` (${d.limit})` : "";
      toast.error(msg + extra, { id: "paywall", action: { label: t.cta, onClick: () => nav("/pricing") } });
    };
    window.addEventListener("pp:paywall", h);
    return () => window.removeEventListener("pp:paywall", h);
  }, [lang, nav]);
  return null;
}
